import { ChangeDetectionStrategy, Component, Input, input } from '@angular/core';

import { ButtonComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-placeholder-button',
  templateUrl: './placeholder-button.component.html',
  styleUrls: ['./placeholder-button.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent],
})
export class PlaceholderButtonComponent {
  public readonly disabled = input<boolean>(false);

  private textWithoutBrackets: string;

  @Input()
  public set text(str: string) {
    this.textWithoutBrackets = str.slice(1, -1);
  }

  public get text(): string {
    return this.textWithoutBrackets;
  }
}
